module.exports = __webpack_public_path__ + "static/media/story-5.6e525c96.jpg";